import React from "react";
import { CheckboxInput } from "@fidget/common/components/form/checkboxInput";

interface Props {
  isSelected: boolean;
  onChange(value: boolean): void;
  id: string;
}
export const ElementFormCheckbox = ({ id, onChange, isSelected }: Props) => {
  return <CheckboxInput id={id} onChange={onChange} value={isSelected} noMarginBottom />;
};
